import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, User } from 'lucide-react';
interface AgencyNavProps {
  activeView: 'browse' | 'booking' | 'mybookings';
  setActiveView: (view: 'browse' | 'booking' | 'mybookings') => void;
}
export function AgencyNav({
  activeView,
  setActiveView
}: AgencyNavProps) {
  return <nav className="bg-white border-b border-stone-200 sticky top-0 z-50" data-id="element-14">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-15">
        <div className="flex items-center gap-8" data-id="element-16">
          <Link to="/" className="font-serif text-xl tracking-tight text-stone-900 flex items-center gap-2" data-id="element-17">
            <div className="w-6 h-6 bg-red-600 flex items-center justify-center" data-id="element-18">
              <span className="font-serif text-sm font-bold text-white" data-id="element-19">B</span>
            </div>
            BlockQuote
          </Link>

          <div className="hidden md:flex items-center gap-6" data-id="element-20">
            <button onClick={() => setActiveView('browse')} className={`text-sm font-medium transition-colors ${activeView === 'browse' || activeView === 'booking' ? 'text-red-600' : 'text-stone-500 hover:text-stone-900'}`} data-id="element-21">
              Browse Resorts
            </button>
            <button onClick={() => setActiveView('mybookings')} className={`text-sm font-medium transition-colors ${activeView === 'mybookings' ? 'text-red-600' : 'text-stone-500 hover:text-stone-900'}`} data-id="element-22">
              My Bookings
            </button>
          </div>
        </div>

        <div className="flex items-center gap-6" data-id="element-23">
          <div className="hidden md:flex items-center gap-3" data-id="element-24">
            <div className="text-right" data-id="element-25">
              <p className="text-sm font-medium text-stone-900" data-id="element-26">Sarah Chen</p>
              <p className="font-mono text-xs text-stone-500" data-id="element-27">
                DestaWed Travel
              </p>
            </div>
            <div className="w-8 h-8 rounded-full bg-stone-100 flex items-center justify-center border border-stone-200" data-id="element-28">
              <User className="w-4 h-4 text-stone-500" data-id="element-29" />
            </div>
          </div>
          <Link to="/" className="flex items-center text-stone-400 hover:text-stone-900 transition-colors font-mono text-xs uppercase tracking-widest" data-id="element-30">
            <ArrowLeft className="w-3 h-3 mr-1.5" data-id="element-31" />
            Exit
          </Link>
        </div>
      </div>
    </nav>;
}